import { render } from "./failure-card.vue?vue&type=template&id=d4730c7a&scoped=true"
import script from "./failure-card.vue?vue&type=script&lang=js"
export * from "./failure-card.vue?vue&type=script&lang=js"

import "./failure-card.vue?vue&type=style&index=0&id=d4730c7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4730c7a"]])

export default __exports__